<div class="children">
    <li>
        <span *ngIf="item.link" routerLinkActive="active" [routerLink]="item.link ? [item.link] : false"
            class="children__link font-large children__link--level-one" (click)="onItemClicked(item)">
            <i *ngIf="item.icon" class="{{item.icon}}"></i>
            {{item.title | translate}}
            <i *ngIf="item.child" class="icon icon-24-px-chevron" [ngClass]="show ? 'rotate-up'  : 'rotate-down'"></i>
            <span class="children__arrow"></span>
        </span>
        <span *ngIf="!item.link" class="children__link font-large children__link--level-one"
            [ngClass]="{'active':item.active}" (click)="onItemClicked(item)">
            <i *ngIf="item.icon" class="{{item.icon}}"></i>
            {{item.title | translate}}
            <i *ngIf="item.child" class="icon icon-24-px-chevron" [ngClass]="show ? 'rotate-up'  : 'rotate-down'"></i>
            <span class="children__arrow"></span>
        </span>
        <ul *ngIf="item.child && show" class="children__list font-large children__list--level-two">
            <mapfre-auditlib-menu-item *ngFor="let subitem of item.child;" [item]="subitem"
                (clicked)="onSubItemClicked($event)">
            </mapfre-auditlib-menu-item>
        </ul>
    </li>
</div>